// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3FXQq","gfeWrapper":"CalendarEvent_gfeWrapper__SxLND"};